// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Coordination_item__sHubr {
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  background: var(--white);
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
}
.Coordination_item__top__il2Bw {
  padding: 12px;
  width: 100%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom: 1px solid #EFF3F5;
}
.Coordination_item__bottom__c4FXN {
  padding: 12px;
  width: 100%;
  background: #FAFAFA;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  display: flex;
}
.Coordination_item__sHubr .Coordination_item__top__not-bot-padding__FhvKc {
  padding-bottom: 0;
}
@media (max-width: 640px) {
  .Coordination_item__top__il2Bw {
    padding: 16px;
    border-bottom: none;
  }
  .Coordination_item__bottom__c4FXN {
    padding: 0 16px 16px;
    background: var(--white);
  }
}

.Coordination_title__KKCfg {
  display: flex;
  width: 100%;
}
.Coordination_title__name__Nka5J {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Coordination_title__author__NTfDI {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}
.Coordination_title__author-name__4j3Ny {
  line-height: 114%;
}
.Coordination_title__author-avatar__2bN-s {
  width: 28px;
  height: 28px;
}
@media (max-width: 640px) {
  .Coordination_title__author-avatar__2bN-s {
    width: 24px;
    height: 24px;
  }
}
.Coordination_title__name__shorted__xwRMS {
  max-width: calc(100% - 100px);
}
@media (max-width: 640px) {
  .Coordination_title__KKCfg {
    flex-direction: column;
    gap: 8px;
  }
  .Coordination_title__author__NTfDI {
    margin-left: 0;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}

.Coordination_actions-btn-container__qEQli {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
@media (max-width: 640px) {
  .Coordination_actions-btn-container__qEQli {
    width: 100%;
  }
}

.Coordination_body__-plAI {
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin-top: 4px;
}
@media (max-width: 640px) {
  .Coordination_body__-plAI.Coordination_body__greyed__TSHwH {
    padding: 8px;
    background: #F9FAFB;
    border-radius: 8px;
    margin-top: 8px;
  }
}

.Coordination_status-content__7Wsch {
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (max-width: 640px) {
  .Coordination_status-content__7Wsch {
    flex-direction: column-reverse;
  }
}

.Coordination_status-time__GlqnU {
  font-size: 12px;
  line-height: 114%;
  color: #7A808B;
}
.Coordination_status-time__GlqnU b {
  font-weight: 400;
}
@media (max-width: 640px) {
  .Coordination_status-time__GlqnU {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.Coordination_status-time__absolute__w6PdX {
  position: absolute;
  top: 16px;
  right: 16px;
}

.Coordination_textarea__q1EYr {
  min-height: auto;
  border: 1px solid transparent;
}

.Coordination_status-comment__fG7Mt {
  line-height: 114%;
}

.Coordination_text-container__LhLNy {
  margin-top: 8px;
  width: 100%;
  display: flex;
}

.Coordination_text-container__displaced__FVRKx {
  margin-top: 0;
  margin-bottom: 4px;
}

.Coordination_status-label__zt05u {
  padding: 6px 12px;
  display: flex;
  gap: 2px;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  border-radius: 40px;
  margin-left: auto;
  align-items: center;
  height: 28px;
}
.Coordination_status-label__zt05u svg {
  width: 16px;
}
@media (max-width: 640px) {
  .Coordination_status-label__zt05u {
    padding: 0;
    background: none !important;
    margin-left: 0;
    height: auto;
  }
}

.Coordination_status-label-res__f5zU9 {
  background: rgba(45, 190, 100, 0.1215686275);
  color: var(--accent-color);
}

.Coordination_status-label-rej__zeB\\+n {
  background: rgba(245, 77, 77, 0.1215686275);
  color: #F54E4C;
}

.Coordination_highlight__b85Fp {
  background-color: #FFF742;
}

.Coordination_btn__O5c-2 {
  padding: 12px 24px;
}
@media (max-width: 1200px) {
  .Coordination_btn__O5c-2 {
    height: auto;
    width: max-content;
    font-size: var(--fz-sm);
    padding: 16px 24px;
  }
}
@media (max-width: 640px) {
  .Coordination_btn__O5c-2 {
    width: 100%;
  }
}

.Coordination_is-error__7BFSy {
  border: 1px solid var(--error);
}`, "",{"version":3,"sources":["webpack://./src/components/Coordinations/Coordination/Coordination.module.scss"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,wBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,WAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;AACJ;AAEE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE;IACE,aAAA;IACA,mBAAA;EAFJ;EAKE;IACE,oBAAA;IACA,wBAAA;EAHJ;AACF;;AAOA;EACE,aAAA;EACA,WAAA;AAJF;AAME;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AASE;EACE,WAAA;EACA,YAAA;AAPJ;AASI;EAJF;IAKI,WAAA;IACA,YAAA;EANJ;AACF;AASE;EACE,6BAAA;AAPJ;AAUE;EAtCF;IAuCI,sBAAA;IACA,QAAA;EAPF;EASE;IACE,cAAA;IACA,2BAAA;IACA,yBAAA;EAPJ;AACF;;AAWA;EACE,iBAAA;EACA,aAAA;EACA,QAAA;AARF;AAUE;EALF;IAMI,WAAA;EAPF;AACF;;AAUA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAPF;AASE;EACE;IACE,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EAPJ;AACF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AARF;AAUE;EALF;IAMI,8BAAA;EAPF;AACF;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAPF;AASE;EACE,gBAAA;AAPJ;AAUE;EATF;IAUI,aAAA;IACA,mBAAA;IACA,QAAA;EAPF;AACF;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAPF;;AAUA;EACE,gBAAA;EACA,6BAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,eAAA;EACA,WAAA;EACA,aAAA;AAPF;;AAUA;EACE,aAAA;EACA,kBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAPF;AASE;EACE,WAAA;AAPJ;AAUE;EAhBF;IAiBI,UAAA;IACA,2BAAA;IACA,cAAA;IACA,YAAA;EAPF;AACF;;AAUA;EACE,4CAAA;EACA,0BAAA;AAPF;;AAUA;EACE,2CAAA;EACA,cAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;AASE;EAHF;IAII,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,kBAAA;EANF;AACF;AAQE;EAVF;IAWI,WAAA;EALF;AACF;;AAQA;EACE,8BAAA;AALF","sourcesContent":[".item {\n  box-shadow: 0px 5px 9px 0px #0000000D;\n  background: var(--white);\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  position: relative;\n\n  &__top {\n    padding: 12px;\n    width: 100%;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    border-bottom: 1px solid #EFF3F5;\n  }\n\n  &__bottom {\n    padding: 12px;\n    width: 100%;\n    background: #FAFAFA;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    display: flex;\n  }\n\n  .item__top__not-bot-padding {\n    padding-bottom: 0;\n  }\n\n  @media (max-width: 640px) {\n    &__top {\n      padding: 16px;\n      border-bottom: none;\n    }\n\n    &__bottom {\n      padding: 0 16px 16px;\n      background: var(--white);\n    }\n  }\n}\n\n.title {\n  display: flex;\n  width: 100%;\n\n  &__name {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__author {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  &__author-name {\n    line-height: 114%;\n  }\n\n  &__author-avatar {\n    width: 28px;\n    height: 28px;\n\n    @media (max-width: 640px) {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  &__name__shorted {\n    max-width: calc(100% - 100px);\n  }\n\n  @media (max-width: 640px) {\n    flex-direction: column;\n    gap: 8px;\n\n    &__author {\n      margin-left: 0;\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n    }\n  }\n}\n\n.actions-btn-container {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n\n  @media (max-width: 640px) {\n    width: 100%;\n  }\n}\n\n.body {\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  margin-top: 4px;\n\n  @media (max-width: 640px) {\n    &.body__greyed {\n      padding: 8px;\n      background: #F9FAFB;\n      border-radius: 8px;\n      margin-top: 8px;\n    }\n  }\n}\n\n.status-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  @media(max-width: 640px) {\n    flex-direction: column-reverse;\n  }\n}\n\n.status-time {\n  font-size: 12px;\n  line-height: 114%;\n  color: #7A808B;\n\n  b {\n    font-weight: 400;\n  }\n\n  @media (max-width: 640px) {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n}\n\n.status-time__absolute {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.textarea {\n  min-height: auto;\n  border: 1px solid transparent;\n}\n\n.status-comment {\n  line-height: 114%;\n}\n\n.text-container {\n  margin-top: 8px;\n  width: 100%;\n  display: flex;\n}\n\n.text-container__displaced {\n  margin-top: 0;\n  margin-bottom: 4px;\n}\n\n.status-label {\n  padding: 6px 12px;\n  display: flex;\n  gap: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  border-radius: 40px;\n  margin-left: auto;\n  align-items: center;\n  height: 28px;\n\n  svg {\n    width: 16px;\n  }\n\n  @media (max-width: 640px) {\n    padding: 0;\n    background: none!important;\n    margin-left: 0;\n    height: auto;\n  }\n}\n\n.status-label-res {\n  background: #2DBE641F;\n  color: var(--accent-color);\n}\n\n.status-label-rej {\n  background: #F54D4D1F;\n  color: #F54E4C;\n}\n\n.highlight {\n  background-color: #FFF742;\n}\n\n.btn {\n  padding: 12px 24px;\n  \n  @media (max-width: 1200px) {\n    height: auto;\n    width: max-content;\n    font-size: var(--fz-sm);\n    padding: 16px 24px;\n  }\n\n  @media (max-width: 640px) {\n    width: 100%;\n  }\n}\n\n.is-error {\n  border: 1px solid var(--error);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Coordination_item__sHubr`,
	"item__top": `Coordination_item__top__il2Bw`,
	"item__bottom": `Coordination_item__bottom__c4FXN`,
	"item__top__not-bot-padding": `Coordination_item__top__not-bot-padding__FhvKc`,
	"title": `Coordination_title__KKCfg`,
	"title__name": `Coordination_title__name__Nka5J`,
	"title__author": `Coordination_title__author__NTfDI`,
	"title__author-name": `Coordination_title__author-name__4j3Ny`,
	"title__author-avatar": `Coordination_title__author-avatar__2bN-s`,
	"title__name__shorted": `Coordination_title__name__shorted__xwRMS`,
	"actions-btn-container": `Coordination_actions-btn-container__qEQli`,
	"body": `Coordination_body__-plAI`,
	"body__greyed": `Coordination_body__greyed__TSHwH`,
	"status-content": `Coordination_status-content__7Wsch`,
	"status-time": `Coordination_status-time__GlqnU`,
	"status-time__absolute": `Coordination_status-time__absolute__w6PdX`,
	"textarea": `Coordination_textarea__q1EYr`,
	"status-comment": `Coordination_status-comment__fG7Mt`,
	"text-container": `Coordination_text-container__LhLNy`,
	"text-container__displaced": `Coordination_text-container__displaced__FVRKx`,
	"status-label": `Coordination_status-label__zt05u`,
	"status-label-res": `Coordination_status-label-res__f5zU9`,
	"status-label-rej": `Coordination_status-label-rej__zeB+n`,
	"highlight": `Coordination_highlight__b85Fp`,
	"btn": `Coordination_btn__O5c-2`,
	"is-error": `Coordination_is-error__7BFSy`
};
export default ___CSS_LOADER_EXPORT___;
